export const AUTH_TOKEN = "auth_token";
export const USER_ID = "user_id";
export const COMPANY_NAME = "company_name";
export const COMPANY_LOGO = "company_logo_url";
export const APP_ID = 1793642705;
export const CLIENT_ID =
  "286236753516-ulb88leolrvv023vghr8oq2jkbr1qs68.apps.googleusercontent.com";
